import PropTypes from 'prop-types'
import useCMSRequest from './hooks/useCMSRequest'

CMSAsset.propTypes = {
  children: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired
}

export default function CMSAsset({ children, id }) {
  const response = useCMSRequest(`/assets/${id}`)

  if (response) {
    const props = { ...response.fields, id: response.sys.id }
    return children(props)
  }

  return null
}
